export enum UserRoles {
  ADMIN = 'Admin',
  CS_AGENT = 'CS_Agent',
  FR = 'FR', //Field representative
  ME_ADMIN = 'ME_Admin', //MedicalEntity_Admin
  GME_ADMIN = 'GME_Admin', //GroupMedicalEntity_Admin
  TPA_ADMIN = 'TPA_Admin', //GroupMedicalEntity_Admin
  DEV_USER = 'Dev_User',
}
